import { AppRoutingConstants } from "../app-routing.constants";
export class ViewApplicationRoutingConstants {
    static VIEW_APPLICATION_ROUTE = AppRoutingConstants.createRouteToView("view-application");
    static JOB_ID_ROUTE_PARAMETER = ":jobID";
    static VIEW_APPLICATION_HEADING_TEXT = "View application";
    static APPLICATION_CONTENT_ROUTE = AppRoutingConstants.createRouteToView("content");
    static APPLICATION_STATUS_ROUTE = AppRoutingConstants.createRouteToView("status");
    static REQUIRED_DOCS = AppRoutingConstants.createRouteToView("documentation");
    static COMMUNICATION = AppRoutingConstants.createRouteToView("communication");
    static COMMENTS = AppRoutingConstants.createRouteToView("comments");
    static LOCATION_ROUTE = AppRoutingConstants.createRouteToView("location");
    static DETAILS_ROUTE = AppRoutingConstants.createRouteToView("details");
    static APPLICANT_ROUTE = AppRoutingConstants.createRouteToView("applicant");
    static AGENT_ROUTE = AppRoutingConstants.createRouteToView("agent");
    static BURIAL_ROUTE = AppRoutingConstants.createRouteToView("burialdetails");
    static DECEASED_ROUTE = AppRoutingConstants.createRouteToView("deceaseddetails");
    static FAMILY_ROUTE = AppRoutingConstants.createRouteToView("familymemberdetails");
    static FUNERAL_PARLOUR = AppRoutingConstants.createRouteToView("funeralparlour");
    static PROFESSIONAL_BODIES_ROUTE = AppRoutingConstants.createRouteToView("professionalbodies");
    static TRADERS_ROUTE = AppRoutingConstants.createRouteToView("traders");
    static NOTES_ROUTE = AppRoutingConstants.createRouteToView("notes");
    static PEOPLE_OF_INTEREST_ROUTE = AppRoutingConstants.createRouteToView("peopleofinterest");
}
